import { useEffect, useState } from "react";
import { useCreateHeyLightAdminAxiosInstance } from "../../Auth/useCreateHeyLightAdminAxiosInstance.ts";
import { MoneyDTO } from "../../ProductService/NormasTeachingProduct/useNormasTeachingProductById.ts";

export type HeyLightRefundRecord = {
  _id: string;
  amountInCent?: MoneyDTO;
  totalRefund?: boolean;
  createdAt: string;
};

export function useGetHeyLightRefundRecord(orderId: string | null) {
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();
  const [refund, setRefund] = useState<HeyLightRefundRecord | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orderId) return;
    setLoading(true);
    createAxiosInstance()
      .get<{ refund: HeyLightRefundRecord | null }>(
        `/admin/orders/${orderId}/refund-record`,
      )
      .then(({ data }) => setRefund(data.refund))
      .catch(() => setRefund(null))
      .finally(() => setLoading(false));
  }, [orderId]);

  return { refund, loading };
}
